import React from "react";

/**
 * Component shown when joining a meeting
 * @returns {JSX.Element} JoiningMeeting component
 */
const JoiningMeeting = () => {
  return (
    <div
      className="fixed inset-0 bg-gradient-to-b from-white to-gray-100 flex items-center justify-center z-[9999]"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
      }}
    >
      {/* Background decorative elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-1/4 w-64 h-64 rounded-full bg-[#A40165]/5 blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-80 h-80 rounded-full bg-[#A40165]/5 blur-3xl"></div>
        <div className="absolute top-1/3 right-1/3 w-40 h-40 rounded-full bg-purple-200/20 blur-2xl"></div>
      </div>
      <div className="bg-white/80 backdrop-blur-sm rounded-3xl shadow-xl overflow-hidden border border-gray-200 p-8">
        <div className="flex flex-col items-center justify-center py-12">
          {/* Phone icon with pulsating rings */}
          <div className="relative mb-8">
            {/* Pulsating rings */}
            <div
              className="absolute inset-0 rounded-full border-2 border-[#A40165]/30 animate-ping"
              style={{ transform: "scale(1.8)", animationDuration: "2s" }}
            ></div>
            <div
              className="absolute inset-0 rounded-full border-2 border-[#A40165]/20 animate-ping"
              style={{
                transform: "scale(1.5)",
                animationDuration: "2.5s",
                animationDelay: "0.2s",
              }}
            ></div>
            <div
              className="absolute inset-0 rounded-full border-2 border-[#A40165]/10 animate-ping"
              style={{
                transform: "scale(1.2)",
                animationDuration: "3s",
                animationDelay: "0.4s",
              }}
            ></div>

            {/* Phone icon */}
            <div className="relative w-20 h-20 rounded-full bg-[#A40165] flex items-center justify-center shadow-lg z-10">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-10 w-10 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                />
              </svg>
            </div>
          </div>

          {/* Status text */}
          <h1 className="text-2xl font-bold text-gray-800 tracking-wide flex items-center">
            Connecting to call
            <span className="ml-2 flex">
              <span className="animate-bounce text-[#A40165]">.</span>
              <span
                className="animate-bounce text-[#A40165]"
                style={{ animationDelay: "200ms" }}
              >
                .
              </span>
              <span
                className="animate-bounce text-[#A40165]"
                style={{ animationDelay: "400ms" }}
              >
                .
              </span>
            </span>
          </h1>

          {/* Status message */}
          <p className="text-gray-600 mt-4 text-center">
            Please wait while we establish a secure connection
          </p>

          {/* Progress bar */}
          <div className="w-64 h-1 bg-gray-200 rounded-full mt-8 overflow-hidden">
            <div
              className="h-full bg-[#A40165] rounded-full animate-pulse"
              style={{ width: "70%" }}
            ></div>
          </div>

          {/* Additional status */}
          <p className="text-gray-400 text-sm mt-4">
            This may take a few moments
          </p>
        </div>
      </div>
    </div>
  );
};

export default JoiningMeeting;
